import { render, staticRenderFns } from "./BlocInfoTiers.vue?vue&type=template&id=c9b8ae98"
import script from "./BlocInfoTiers.vue?vue&type=script&lang=js"
export * from "./BlocInfoTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports